/* Magnesium Glycinate PDP (IM8 replica) — gallery, size + plan pricing, cart,
   ClinicianAI widget, accordions, carousels, clinician filter, reviews toggle,
   body-system switcher, nutrition modal, sticky bar.
   No Liquid here: money format + variant data arrive via data-attributes. */
(function(){
  var root = document.querySelector('[data-m8]');
  if(!root) return;

  /* ---- money -------------------------------------------------------- */
  var sample = root.dataset.moneySample || '$1.00';
  var sym = sample.replace(/[0-9.,\s]/g, '');
  function money(cents, forceDec){
    var n = cents / 100;
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return sym + ((whole && !forceDec) ? String(Math.round(n)) : n.toFixed(2));
  }

  /* ---- variants: [{id, caps, days, price, was}] ---------------------- */
  var variants = JSON.parse(root.dataset.variants);
  var sizeIdx = variants.length - 1;   /* default 180 caps (BEST) */
  var plan = 'sub';                    /* 'sub' (30% off) | 'one' */

  function cur(){ return variants[sizeIdx]; }
  function subPrice(){ return Math.round(cur().price * 70 / 100); }
  function months(){ return Math.max(1, Math.round(cur().days / 30)); }
  function perMonth(){ return Math.round(subPrice() / months()); }
  function perServingSub(){ return Math.round(subPrice() / cur().days); }
  function perServingOne(){ return Math.round(cur().price / cur().days); }

  function text(sel, s){ var el = root.querySelector(sel); if(el) el.textContent = s; }

  function paint(){
    root.querySelectorAll('[data-m8-size]').forEach(function(b, i){
      b.classList.toggle('is-on', i === sizeIdx);
    });
    root.querySelectorAll('[data-m8-plan]').forEach(function(b){
      b.classList.toggle('is-on', b.dataset.m8Plan === plan);
    });
    var v = cur();
    /* subscribe card */
    text('[data-m8-sub-title]', v.days + '-Day Supply');
    text('[data-m8-sub-now]', money(perMonth()));
    text('[data-m8-sub-was]', money(Math.round(v.price / months())) + ' /mo');
    text('[data-m8-sub-billed]', 'Billed ' + money(subPrice(), true) + ' USD every ' + (months() * 4) + ' weeks');
    text('[data-m8-sub-serv]', money(perServingSub(), true) + ' USD / SERVING');
    /* one-time card */
    text('[data-m8-one-now]', money(v.price));
    text('[data-m8-one-was]', money(v.was) + ' /mo');
    text('[data-m8-one-serv]', money(perServingOne(), true) + ' USD / SERVING');
    text('[data-m8-one-caps]', v.caps + ' capsules, shipped once');
    text('[data-m8-one-link]', money(v.price));
    /* CTA + sticky */
    var ctaLabel = plan === 'sub'
      ? 'SAVE 30% + FREE GIFTS'
      : 'ADD TO CART – ' + money(v.price, true) + ' USD';
    text('[data-m8-cta]', ctaLabel);
    var compact = window.matchMedia('(max-width:620px)').matches;
    text('[data-m8-sticky-atc]', compact ? 'ADD' : (plan === 'sub'
      ? 'ADD TO CART - ' + money(perMonth(), true) + ' USD/MO'
      : 'ADD TO CART - ' + money(v.price, true) + ' USD'));
    var sel = root.querySelector('[data-m8-sticky-sel]');
    if(sel) sel.value = String(sizeIdx) + ':' + plan;
  }

  root.querySelectorAll('[data-m8-size]').forEach(function(b, i){
    b.addEventListener('click', function(){ sizeIdx = i; paint(); });
  });
  root.querySelectorAll('[data-m8-plan]').forEach(function(b){
    b.addEventListener('click', function(e){
      if(e.target.closest('[data-m8-gifts]')) return;   /* gifts toggle lives inside the card */
      plan = b.dataset.m8Plan; paint();
    });
  });
  var giftsBtn = root.querySelector('[data-m8-gifts]');
  if(giftsBtn) giftsBtn.addEventListener('click', function(e){
    e.stopPropagation();
    giftsBtn.closest('[data-m8-plan]').classList.toggle('gifts-open');
  });
  var oneLink = root.querySelector('[data-m8-onetime]');
  if(oneLink) oneLink.addEventListener('click', function(){ plan = 'one'; paint(); });

  var stickySel = root.querySelector('[data-m8-sticky-sel]');
  if(stickySel) stickySel.addEventListener('change', function(){
    var p = stickySel.value.split(':');
    sizeIdx = parseInt(p[0], 10); plan = p[1]; paint();
  });

  /* ---- add to cart ---------------------------------------------------- */
  function addToCart(){
    var v = cur();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: v.id, quantity: 1 })
    }).then(function(r){
      if(!r.ok) throw new Error('cart');
      window.themeGoToCheckout();
    }).catch(function(){
      window.location.href = '/cart/add?id=' + v.id + '&quantity=1';
    });
  }
  root.querySelectorAll('[data-m8-add]').forEach(function(b){ b.addEventListener('click', addToCart); });

  /* ---- gallery + nutrition modal -------------------------------------- */
  var stage = root.querySelector('[data-m8-stage]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-m8-thumb]'));
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      thumbs.forEach(function(o){ o.classList.remove('is-on'); });
      t.classList.add('is-on');
      if(stage) stage.src = t.dataset.m8Thumb;
    });
  });
  var tNext = root.querySelector('[data-m8-thumbs-next]');
  if(tNext) tNext.addEventListener('click', function(){
    var i = thumbs.findIndex(function(t){ return t.classList.contains('is-on'); });
    thumbs[(i + 1) % thumbs.length].click();
  });
  var modal = root.querySelector('[data-m8-modal]');
  root.querySelectorAll('[data-m8-nutrition]').forEach(function(b){
    b.addEventListener('click', function(){ modal.classList.add('is-open'); });
  });
  if(modal){
    modal.addEventListener('click', function(e){
      if(e.target === modal || e.target.closest('[data-m8-modal-x]')) modal.classList.remove('is-open');
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') modal.classList.remove('is-open'); });
  }

  /* ---- ClinicianAI widget --------------------------------------------- */
  var aiInput = root.querySelector('[data-m8-ai-input]');
  root.querySelectorAll('[data-m8-ai-tab]').forEach(function(t){
    t.addEventListener('click', function(){
      root.querySelectorAll('[data-m8-ai-tab]').forEach(function(o){ o.classList.remove('is-on'); });
      t.classList.add('is-on');
    });
  });
  root.querySelectorAll('[data-m8-ai-chip]').forEach(function(c){
    c.addEventListener('click', function(){ if(aiInput) aiInput.value = c.textContent.trim(); });
  });
  var aiAsk = root.querySelector('[data-m8-ai-ask]');
  if(aiAsk) aiAsk.addEventListener('click', function(){
    var target = root.querySelector('#m8-clinicians');
    if(target) target.scrollIntoView({behavior: 'smooth'});
  });

  /* ---- accordions (buy box + FAQ) -------------------------------------- */
  root.querySelectorAll('[data-m8-acc]').forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.closest('[data-m8-acc-item]').classList.toggle('is-open');
    });
  });

  /* ---- ambassador carousel dots ----------------------------------------- */
  root.querySelectorAll('[data-m8-carousel]').forEach(function(wrap){
    var track = wrap.querySelector('[data-m8-track]');
    var dotsEl = wrap.querySelector('.rev-m8__dots');
    if(!track || !dotsEl) return;
    function step(){ var c = track.children[0]; return c ? c.offsetWidth + 20 : 300; }
    function pages(){ return Math.max(1, track.children.length - Math.round((track.clientWidth + 20) / step()) + 1); }
    function dots(){
      var n = pages(), curP = Math.min(n - 1, Math.round(track.scrollLeft / step())), html = '';
      for(var i = 0; i < n; i++) html += '<i' + (i === curP ? ' class="is-on"' : '') + '></i>';
      dotsEl.innerHTML = html;
    }
    var t; track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(dots, 80); }, {passive: true});
    window.addEventListener('resize', dots);
    dots();
  });

  /* ---- clinician filter + pager ----------------------------------------- */
  var docCards = Array.prototype.slice.call(root.querySelectorAll('[data-m8-doc]'));
  var docCat = 'All', docPage = 0, DOCS_PER = 3;
  function paintDocs(){
    var vis = docCards.filter(function(c){
      return docCat === 'All' || c.dataset.m8Doc === docCat;
    });
    var maxPage = Math.max(0, Math.ceil(vis.length / DOCS_PER) - 1);
    if(docPage > maxPage) docPage = maxPage;
    docCards.forEach(function(c){ c.style.display = 'none'; });
    vis.slice(docPage * DOCS_PER, docPage * DOCS_PER + DOCS_PER).forEach(function(c){ c.style.display = ''; });
    text('[data-m8-doc-count]', vis.length + ' REVIEWS');
  }
  root.querySelectorAll('[data-m8-chip]').forEach(function(ch){
    ch.addEventListener('click', function(){
      root.querySelectorAll('[data-m8-chip]').forEach(function(o){ o.classList.remove('is-on'); });
      ch.classList.add('is-on');
      docCat = ch.dataset.m8Chip; docPage = 0; paintDocs();
    });
  });
  var dPrev = root.querySelector('[data-m8-doc-prev]'), dNext = root.querySelector('[data-m8-doc-next]');
  if(dPrev) dPrev.addEventListener('click', function(){ if(docPage > 0){ docPage--; paintDocs(); } });
  if(dNext) dNext.addEventListener('click', function(){ docPage++; paintDocs(); });
  root.querySelectorAll('[data-m8-doc-more]').forEach(function(b){
    b.addEventListener('click', function(){
      var q = b.closest('[data-m8-doc]').querySelector('blockquote');
      q.style.display = q.style.display === 'none' ? '' : 'none';
    });
  });
  paintDocs();

  /* ---- verified reviews show more ---------------------------------------- */
  var showBtn = root.querySelector('[data-m8-show-reviews]');
  if(showBtn) showBtn.addEventListener('click', function(){
    var extra = root.querySelectorAll('[data-m8-vr-extra]');
    var hidden = extra[0] && extra[0].hidden;
    extra.forEach(function(e){ e.hidden = !hidden; });
    showBtn.textContent = hidden ? 'SHOW FEWER REVIEWS' : 'SHOW MORE REVIEWS  ⌄';
  });

  /* ---- body systems -------------------------------------------------------- */
  var sysData = JSON.parse(root.querySelector('[data-m8-sys-data]').textContent);
  var sysCard = root.querySelector('[data-m8-sys-card]');
  root.querySelectorAll('[data-m8-sys]').forEach(function(ch, i){
    ch.addEventListener('click', function(){
      root.querySelectorAll('[data-m8-sys]').forEach(function(o){ o.classList.remove('is-on'); });
      ch.classList.add('is-on');
      var d = sysData[i];
      sysCard.querySelector('b').textContent = d.t;
      sysCard.querySelector('p').textContent = d.c;
    });
  });

  /* ---- sticky bar offset above Shopify's preview bar ----------------------- */
  var sticky = root.querySelector('[data-m8-sticky]');
  var pbar = document.getElementById('PBarNextFrameWrapper');
  if(sticky && pbar) sticky.style.bottom = pbar.getBoundingClientRect().height + 'px';

  window.addEventListener('resize', paint);
  paint();
})();
